// Modal Box
export const setModalOpen = '@response/setModalOpen';
export const setModalType = '@response/setModalType';
// All items
export const setItems = '@response/setItems';
// Current Selected Item
export const setSelectedItem = '@response/setSelectedItem';
// Items Status
export const setTemplateType = '@response/setTemplateType';
// Pagination
export const setCurrentPage = '@response/setCurrentPage';
export const setItemsPerPage = '@response/setItemsPerPage';
export const setPaginationMeta = '@response/setPaginationMeta';
// Reload
export const setReload = '@response/setReload';
// SetLoading
export const setIsLoading = '@response/setIsLoading';
export const setSelectedItems = '@response/setSelectedItems';
export const setSearchText = '@response/setSearchText';
export const setAllQuestionRegistriesIds = '@response/setAllQuestionRegistriesIds';
export const setAllChecked = '@response/setAllChecked';
export const setActionType = '@response/setActionType';
export const setHasInputChange = '@response/setHasInputChange';
export const setHasInputNoChange = '@response/setHasInputNoChange';
export const setIsConfirmationModalOpen = '@respone/setIsConfirmationModalOpen';
export const clearAddEditModalValue = '@respone/clearAddEditModalValue';
export const setLockedTime = '@response/setLockedTime';
export const setLockedAddToRegistryQuestionCount = '@response/setLockedAddToRegistryQuestionCount';
export const setUnLockedAddToRegistryQuestionCount = '@response/setUnLockedAddToRegistryQuestionCount';
//Import csv
export const setSelectedCsvFile = '@response/setSelectedCsvFile';
export const setParseDataOfCsvFile = '@response/setParseDataOfCsvFile';
export const setSelectedCsvFileName = '@response/setSelectedCsvFileName';
export const setSelectedCsvItem = '@response/setSelectedCsvItem';
export const setSelectedCsvItemIndex = '@response/setSeletedCsvItemIndex';
